import { useRef } from 'react';

import { CardModal, CustomScrollViewProps } from 'components/card-modal';

import { CartContent } from './components/cart-content';
import { CartContentDebug } from './components/cart-debug';
import { CartDebugFooter } from './components/cart-debug/cart-debug-footer';
import { CartFooter } from './components/cart-footer';
import { CartHeader } from './components/cart-header';
import { useCartContext } from './hooks/use-cart-context';
import { useCartInit } from './hooks/use-cart-init';

export const CartScreen = () => {
  const { debug, cartEntries, setCartState } = useCartContext();
  const cartScrollView = useRef<CustomScrollViewProps>(undefined);
  useCartInit({ cartEntries, setCartState });

  return (
    <CardModal
      key="cart"
      _headerOverride={<CartHeader />}
      scrollViewRef={cartScrollView}
      scrollView
      webAnimate={false}
      standardPadding
      invertHeaderColor
      isFullScreen
      footer={debug ? <CartDebugFooter /> : <CartFooter />}
    >
      {debug ? <CartContentDebug /> : <CartContent />}
    </CardModal>
  );
};
